/**
 * 매물의 위치로 지도를 포커스하는 공통 함수
 * @param {Object} property - 매물 객체 (lat, lng 필수)
 * @param {Object} options - 옵션 객체
 * @param {Function} options.setActiveTab - 탭 전환 함수
 * @param {string} options.currentTab - 현재 활성 탭
 * @param {Object} options.mapRef - 지도 ref 객체
 * @param {Function} options.onSuccess - 성공 시 콜백 (선택)
 */
export function focusOnPropertyLocation(property, options = {}) {
  const { setActiveTab, currentTab, mapRef, onSuccess } = options;

  console.log('focusOnPropertyLocation 호출:', { property, options });

  if (!property?.lat || !property?.lng) {
    console.warn('매물에 좌표가 없습니다:', property);
    return;
  }

  const lat = Number(property.lat);
  const lng = Number(property.lng);

  console.log('좌표 변환:', { 
    원본: { lat: property.lat, lng: property.lng }, 
    변환: { lat, lng },
    propertyId: property?.id 
  });

  if (isNaN(lat) || isNaN(lng)) {
    console.warn('유효하지 않은 좌표:', { lat, lng, 원본: { lat: property.lat, lng: property.lng } });
    return;
  }

  // propertyId 추출 (문자열 또는 숫자 모두 처리)
  const propertyId = property?.id ? (typeof property.id === 'string' ? parseInt(property.id) : property.id) : null;
  
  console.log('최종 전달 값:', { lat, lng, propertyId });

  // 탭이 'map'이 아니면 먼저 탭 전환
  if (currentTab !== 'map' && setActiveTab) {
    setActiveTab('map');
    // 탭 전환 후 지도가 준비될 때까지 기다림
    let attempts = 0;
    const tryFocus = () => {
      attempts++;
      if (mapRef?.current?.focusOnLocation) {
        mapRef.current.focusOnLocation(lat, lng, propertyId);
        if (onSuccess) onSuccess();
      } else if (attempts < 15) {
        setTimeout(tryFocus, 150);
      } else {
        console.error('지도 포커스 실패: 최대 시도 횟수 초과');
      }
    };
    setTimeout(tryFocus, 300);
  } else {
    // 이미 'map' 탭이면 바로 이동
    let attempts = 0;
    const tryFocus = () => {
      attempts++;
      if (mapRef?.current?.focusOnLocation) {
        mapRef.current.focusOnLocation(lat, lng, propertyId);
        if (onSuccess) onSuccess();
      } else if (attempts < 10) {
        setTimeout(tryFocus, 100);
      } else {
        console.error('지도 포커스 실패: 최대 시도 횟수 초과');
      }
    };
    tryFocus();
  }
}

